import { Component } from "@angular/core";

import { NavParams, MenuController, NavController } from "ionic-angular";
import { APIServiceProvider } from "../../../common/services/api.service";

import { InventoryPendingStockPage } from "../inventorypendingstock/inventorypendingstock";
import { InventoryPendingProcurementPage } from "../inventorypendingprocurement/inventorypendingprocurement";
import { InventoryPendingOrdersPage } from "../inventorypendingorders/inventorypendingorders";

@Component({
  selector: "tabs-inventorypending",
  templateUrl: "tabs-inventorypending.html"
})
export class TabInventoryPending {
  // set the root pages for each tab
  ipstocktransfer = InventoryPendingStockPage;
  iporders = InventoryPendingOrdersPage;
  ipprocurement = InventoryPendingProcurementPage;

  mySelectedIndex: number = 0;

  constructor(
    navParams: NavParams,
    public menu: MenuController,
    public navCtrl: NavController,
    public apiService: APIServiceProvider
  ) {}

  public inventoryCounts: any = {
    st: 0,
    order: 0,
    procurement: 0
  };

  ionViewDidLoad() {
    this.menu.enable(true);

    this.apiService
      .get(
        "inventory/get-pending-transactions-count?manager_id=" +
          localStorage.getItem("manager_user_id")
      )
      .subscribe(response => {
        this.inventoryCounts.st = response["data"]["stock_transfer"];
        this.inventoryCounts.order = response["data"]["order"];
        this.inventoryCounts.procurement = response["data"]["inward"];
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/inventory/inventorypendingtabs/tabs-inventorypending.ts